// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Container, Navbar, Dropdown, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/taxavenger-logo.png';
import avtar from '../../assets/images/avtar-male.png';
import { useState } from 'react';
import { IoLogOutOutline } from 'react-icons/io5';
import { HiMenuAlt3 } from 'react-icons/hi';

const Header = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [show, setShow] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleClose = () => setShow(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleShow = () => setShow(true);

  // State to track whether the menu is open or closed
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Function to toggle the menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <header className="site-header">
        <Container className="header-nav">
          <div className="d-flex justify-content-start align-items-center">
            <div style={{ width: '95px', height: '60px' }}>
              <Link to={'/home'}>
                <img src={Logo} alt="Taxavenger" className="logo-width" />
              </Link>
            </div>

            <div className="d-none d-sm-block my-auto">
              <Nav className="my-auto">
                <Nav.Item>
                  <Nav.Link as={Link} to="/about-us">
                    About Us
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/assist-your-import">
                    Assist Your Import
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/contact-us">
                    Contact Us
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/feedback">
                    Feedback
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/blogs">
                    Blogs
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
          </div>

          {/* Mobile menu */}
          <button
            onClick={toggleMenu}
            className="menu-toggle d-block d-sm-none"
            style={{ cursor: 'pointer' }}
          >
            <HiMenuAlt3 />
          </button>

          <nav className={`mobile-menu ${isMenuOpen ? 'open' : 'closed'}`}>
            <ul className="mobile-nav">
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/first-import">First Import</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link to="/feedback">Feedback</Link>
              </li>
              <li>
                <Link to="/blogs">Blogs</Link>
              </li>
            </ul>
          </nav>

          <div>
            <Dropdown className="profile-dd d-none">
              <Dropdown.Toggle>
                <div className="d-flex gap-2">
                  <div>
                    <img
                      src={avtar}
                      width={35}
                      height={35}
                      className=" rounded-circle object-fit-cover"
                      alt=""
                    />
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <Dropdown.Item as={Link} to="/home">
                  <IoLogOutOutline size="16" className="me-1" />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Container>
      </header>
    </>
  );
};
export default Header;
